import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { formatMoney } from '@dorixona/utils'
import { BackButton } from '../../ui/BackButton'
import { Failed, Loading } from '../../ui/Load'
import { useStores } from '../stores/api'
import { StoresOnMap } from '../stores/StoresOnMap'
import { useAvailability } from './api'
import { StockPill } from './StockPill'

/**
 * Где есть товар — на карте. Только аптеки из списка «Наличие в аптеках» и в
 * том же порядке. Точки, адрес и часы — из списка аптек сети, у наличия их
 * нет; аптеку без точки на карту не поставить — её здесь нет. Карта, выбор и
 * «Где я» — общие с мультипоиском (`StoresOnMap`).
 */
export function ProductStoresScreen() {
  const { productId } = useParams()
  const id = Number(productId)
  const { t } = useTranslation(['catalog', 'common'])
  const availability = useAvailability(id)
  const stores = useStores()

  const rows = (availability.data ?? []).flatMap((row) => {
    const store = stores.data?.find((item) => item.id === row.storeId)
    return store && store.lat !== null && store.lng !== null
      ? [
          {
            store,
            name: row.storeName,
            side: (
              <>
                <b className="num">{formatMoney(row.price)}</b>
                <StockPill qty={row.qty} />
              </>
            ),
          },
        ]
      : []
  })
  const pending = availability.isPending || stores.isPending
  const failed = availability.isError ? availability : stores.isError ? stores : null

  return (
    <section className="screen checkout-wrap">
      <div className="mhead">
        <BackButton to={`/catalog/${id}`} />
        <h1>{t('catalog:productMap.title')}</h1>
      </div>

      {pending ? <Loading what={t('common:state.loading')} count={2} /> : null}
      {failed ? (
        <Failed
          error={failed.error}
          onRetry={() => {
            void failed.refetch()
          }}
        />
      ) : null}
      {!pending && !failed && rows.length === 0 ? (
        <div className="card empty">
          <div className="t">{t('catalog:product.noneInStores')}</div>
        </div>
      ) : null}

      {rows.length > 0 ? <StoresOnMap rows={rows} /> : null}
    </section>
  )
}
